// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1afWI","clinicsSelect":"styles_clinicsSelect__2AIQN"};